const videos = document.querySelectorAll("video[data-autoplay]");

const replaceWithPoster = (video) => {
  if (!video.isConnected || !video.poster) return;

  const fallback = document.createElement("img");
  fallback.src = video.poster;
  fallback.alt = video.getAttribute("aria-label") || "";
  fallback.className = `${video.className} video-fallback`;
  fallback.decoding = "async";
  video.replaceWith(fallback);
};

const playWhenReady = (video) => {
  if (video.hasAttribute("data-priority")) {
    video.play().catch(() => {});
    return;
  }

  if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
    video.play().catch(() => {});
    return;
  }

  if (video.dataset.loading === "true") return;

  video.dataset.loading = "true";
  video.preload = "auto";
  video.addEventListener(
    "canplay",
    () => {
      video.dataset.loading = "false";
      if (video.dataset.inViewport === "true") {
        video.play().catch(() => {});
      }
    },
    { once: true },
  );
  video.load();
};

videos.forEach((video) => {
  video.addEventListener("error", () => replaceWithPoster(video), { once: true });
  video.querySelectorAll("source").forEach((source) => {
    source.addEventListener("error", () => replaceWithPoster(video), { once: true });
  });
});

const updatePlayback = (entries) => {
  for (const entry of entries) {
    const video = entry.target;
    video.dataset.inViewport = String(entry.isIntersecting);

    if (entry.isIntersecting) {
      playWhenReady(video);
    } else {
      video.pause();
    }
  }
};

if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(updatePlayback, {
    rootMargin: "50% 0px",
  });

  videos.forEach((video) => observer.observe(video));
}
